<template>
  <div class="flex justify-center">
    <!--
      Reserves the photo's final box from its served size so the modal does not grow, and jump, once it loads.
      A portrait photo gets a square box and fills it, so the modal height stays the same whatever the photo's shape.
    -->
    <div
      v-if="width && height"
      class="relative max-w-full max-h-[calc(100vw-48px)] sm:max-h-130"
      :style="{ width: `${width}px`, aspectRatio: isPortrait ? '1 / 1' : `${width} / ${height}` }"
    >
      <img
        :src="src"
        :alt="alt"
        class="absolute inset-0 rounded-2xl"
        :class="isPortrait ? 'h-full w-full object-cover object-center' : 'm-auto max-w-full max-h-full'"
      >
    </div>
    <img
      v-else
      :src="src"
      :alt="alt"
      class="max-w-full max-h-[calc(100vw-48px)] rounded-2xl sm:max-h-130"
    >
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(defineProps<{
  src: string;
  alt: string;
  width?: number | null;
  height?: number | null;
}>(), {
  width: null,
  height: null,
});

const isPortrait = computed(
  (): boolean => props.width !== null && props.height !== null && props.height > props.width,
);
</script>
